import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { StorageService } from '@app/services/storage.service'

import { ButtonComponent } from '../../../modules/ui/components/button/button.component'

@Component({
  selector: 'sb-modal-update-invalid-email',
  templateUrl: './update-invalid-email.component.html',
  imports: [ButtonComponent, RouterLink],
})
export class ModalUpdateInvalidEmailComponent extends Confirmable {
  private readonly storageService = inject(StorageService)

  email!: string
}
